import BeneficiariesPanel from './BeneficiariesPanel';

export default BeneficiariesPanel;
